/** Bản dịch tiếng Việt — phải khớp 100% key với `capability.messages.en.ts`. */
export const capabilityMessagesVi = {
    // --- Capability gate: 3 trạng thái phân biệt rõ ---
    "capability.locked.title": "Có trong gói {{plan}}",
    "capability.locked.subtitle": "Gói hiện tại ({{currentPlan}}) chưa bao gồm tính năng này.",
    "capability.locked.cta": "Xem các gói",
    "capability.locked.close": "Đóng",
    "capability.locked.whyTitle": "Bạn sẽ có gì",
    "capability.unavailable.title": "Chưa khả dụng",
    "capability.unavailable.backend": "Tính năng này cần dịch vụ backend chưa được triển khai. Ở đây không hiển thị dữ liệu giả.",
    "capability.unavailable.device": "Không khả dụng trên thiết bị này.",
    "capability.unavailable.perf": "Dữ liệu quá nhiều cho chế độ xem này. Hãy thu hẹp khoảng thời gian.",
    "capability.unavailable.quota": "Đã đạt giới hạn trong ngày.",
    "capability.unavailable.data": "Hiện chưa có dữ liệu cho mã này.",
    "capability.locked.icon": "Tính năng bị khóa",
    "capability.unlocked": "Đã mở",
    // --- Tên gói + giá (PRICING 2026-10-22) ---
    // Nguồn sự thật của giá: `PLAN_DEV_PHASE_OFFICIAL_2026-10-22.md` §1.1 (D1).
    // Sửa giá = sửa 2 dòng ở đây (vi + en) + cập nhật bảng giá trong plan đó.
    "plan.free": "Miễn phí",
    "plan.starter": "Starter",
    "plan.pro": "Pro",
    "plan.enterprise": "Enterprise",
    "plan.custom": "Tùy chỉnh",
    "plan.internal": "Nội bộ",
    "plan.pro.price": "199.000đ/tháng",
    "plan.enterprise.price": "Liên hệ",
    // --- Upsell theo capability ---
    "capability.upsell.indicator_full.title": "Toàn bộ 60+ chỉ báo",
    "capability.upsell.indicator_full.benefit": "Nhóm xu hướng, động lượng, biến động và khối lượng với tham số tùy chỉnh.",
    "capability.upsell.chart_baseline.title": "Biểu đồ Baseline",
    "capability.upsell.chart_baseline.benefit": "So sánh nhiều mã theo tỷ lệ thay đổi tính từ nến hiển thị đầu tiên.",
    "capability.upsell.chart_exotic.title": "Renko, Kagi, Line Break, Point & Figure",
    "capability.upsell.chart_exotic.benefit": "Biểu đồ price action loại bỏ nhiễu giữa các nến.",
    // volume_profile + volume_footprint: xem ghi chú hạ xuống Community ở dưới file.
    // PINE-COPY 2026-10-08: xem ghi chú đầy đủ ở capability.messages.en.ts (round 2).
    // Đã bỏ cả lời hứa "thêm vào biểu đồ" (pipeline chưa tới chart) và sửa số 69 → 54.
    "capability.upsell.pine_editor.title": "Trình soạn thảo Pine và script tùy chỉnh",
    "capability.upsell.pine_editor.benefit": "Tự viết chỉ báo bằng Pine và kiểm tra cú pháp, logic ngay khi gõ.",
    "capability.upsell.pine_functional.title": "Thư viện hàm Pine",
    "capability.upsell.pine_functional.benefit": "54 hàm dựng sẵn trong ta.*, math.* và str.*, cùng plot, plotshape, hline và alertcondition.",
    "capability.upsell.strategy_tester.title": "Bộ kiểm thử chiến lược kèm báo cáo",
    "capability.upsell.strategy_tester.benefit": "Backtest 4 chiến lược dựng sẵn trên dữ liệu đang tải và xem báo cáo giao dịch.",
    "capability.upsell.replay.title": "Bar replay",
    "capability.upsell.replay.benefit": "Xem lại lịch sử từng nến như đang diễn ra trực tiếp.",
    "capability.upsell.replay_trading.title": "Đặt lệnh ngay trong bar replay",
    "capability.upsell.replay_trading.benefit": "Đặt lệnh mô phỏng trong khi đồng hồ replay chạy.",
    "capability.upsell.paper_advanced.title": "Lệnh mô phỏng nâng cao",
    "capability.upsell.paper_advanced.benefit": "Lệnh stop, stop-limit, trailing và PLO kèm quản trị rủi ro danh mục.",
    "capability.upsell.alert_local.title": "Cảnh báo giá và chỉ báo",
    "capability.upsell.alert_local.benefit": "Được thông báo khi giá hoặc chỉ báo cắt qua mức bạn đặt.",
    "capability.upsell.alert_drawing.title": "Cảnh báo theo đường vẽ",
    "capability.upsell.alert_drawing.benefit": "Bắn cảnh báo khi giá cắt đường, kênh hoặc vùng Fibonacci bạn đã vẽ.",
    "capability.upsell.export_png.title": "Lưu biểu đồ thành ảnh",
    "capability.upsell.export_png.benefit": "Xuất toàn bộ bố cục thành ảnh PNG để chia sẻ.",
    "capability.upsell.export_csv.title": "Xuất dữ liệu CSV",
    "capability.upsell.export_csv.benefit": "Tải nến, giá trị chỉ báo và đối tượng vẽ về để tự phân tích.",
    "capability.upsell.auto_pattern.title": "Tự động nhận dạng mô hình nến",
    "capability.upsell.auto_pattern.benefit": "Tự nhận diện vai-rồng-cổ, tam giác, cờ trên biểu đồ.",
    "capability.upsell.layout_user.title": "Lưu bố cục của bạn",
    "capability.upsell.layout_user.benefit": "Giữ bộ thiết lập nhiều biểu đồ và quay lại dùng sau.",
    "capability.upsell.share_local.title": "Đánh dấu và chia sẻ biểu đồ",
    "capability.upsell.share_local.benefit": "Lưu ảnh chụp của bố cục hiện tại.",
    // ĐÃ HẠ XUỐNG COMMUNITY 2026-10-08 — 6 upsell bên dưới bị xoá vì ma trận engine đã hạ
    // chúng về `none`: gap_compression · measure_pane · shortcut_map · scale_sync ·
    // volume_profile · volume_footprint. Copy mà không ai gate là lời hứa sai với khách,
    // và ngược lại nó cũng là lý do cổng `audit:paid-capability` báo nhầm. Xem
    // `docs/system-design/13-ROADMAP/13.03-unshipped-paid-capability-decisions.md`.
    "capability.upsell.multi_chart.title": "Workspace nhiều biểu đồ",
    "capability.upsell.multi_chart.benefit": "Chia màn hình và giữ các pane đồng bộ.",
    // REMOVED 2026-10-22 (D2): `smart_drawing_pro` → Community. The 16 TIER-16 drawing
    // tools were already shipped unminified in `engine-drawing@2.2.0`, so the upsell
    // promised something the product could not withhold. `capabilityMessages.test.ts`
    // fails if a Community capability regains upsell copy.
    "capability.upsell.adjusted_bars.title": "Giá điều chỉnh cổ tức và tách cổ",
    "capability.upsell.adjusted_bars.benefit": "Giá và chỉ báo vẫn đúng qua các mốc chia cổ tức, tách cổ.",
    "capability.upsell.cloud_alert.title": "Cảnh báo chạy trên cloud",
    "capability.upsell.cloud_alert.benefit": "Được đánh giá ở máy chủ, gửi cả khi bạn đã đóng tab.",
    "capability.upsell.webhook.title": "Gửi cảnh báo qua webhook",
    "capability.upsell.webhook.benefit": "Đẩy mọi tín hiệu vào bot hoặc dịch vụ của bạn.",
    "capability.upsell.orderbook_dom.title": "Sổ lệnh (order book)",
    "capability.upsell.orderbook_dom.benefit": "Thang mua/bán trực tiếp kèm khối lượng tổng hợp.",
    "capability.upsell.fundamentals_full.title": "Báo cáo tài chính đầy đủ",
    "capability.upsell.fundamentals_full.benefit": "Kết quả kinh doanh, bảng cân đối và lưu chuyển tiền tệ theo quý và năm.",
    "capability.upsell.index_constituents.title": "Cấu thành chỉ số",
    "capability.upsell.index_constituents.benefit": "Watchlist VN30, VN100 kèm tỷ trọng từng mã.",
    "capability.upsell.deep_history.title": "Lịch sử trong ngày không giới hạn",
    "capability.upsell.deep_history.benefit": "Không còn giới hạn số nến khi cuộn ngược trên khung phút.",
    "capability.upsell.server_pine.title": "Backtest sâu chạy trên server",
    "capability.upsell.server_pine.benefit": "Chạy chiến lược trên toàn bộ lịch sử thay vì chỉ phần nến đã tải.",
    "capability.upsell.server_workspace.title": "Đồng bộ nhiều thiết bị",
    "capability.upsell.server_workspace.benefit": "Bố cục, đối tượng vẽ và cài đặt đi theo bạn giữa các máy.",
    "capability.upsell.realtime_tick.title": "Dữ liệu tick và giây",
    "capability.upsell.realtime_tick.benefit": "Nến dưới một phút cho phân tích lướt giá.",
    "capability.upsell.whale_campaign.title": "Gom nhóm chiến dịch cá mập",
    "capability.upsell.whale_campaign.benefit": "Gom lệnh lớn thành chiến dịch kèm tác động giá.",
    "capability.upsell.portfolio_analytics.title": "Phân tích danh mục",
    "capability.upsell.portfolio_analytics.benefit": "Đường vốn, phân bổ và mức sụt giảm của danh mục.",
    "capability.upsell.dock_pro.title": "Dock phải đầy đủ",
    "capability.upsell.dock_pro.benefit": "Tape, tư vấn và phiếu lệnh ngay cạnh biểu đồ.",
    "capability.upsell.no_ads.title": "Không quảng cáo",
    "capability.upsell.no_ads.benefit": "Biểu đồ sạch, không watermark.",
    "capability.upsell.pro_plugin.title": "Plugin mở rộng Pro",
    "capability.upsell.pro_plugin.benefit": "Nạp thêm bộ vẽ và series từ module mở rộng Pro.",
    "capability.upsell.layout_preset.title": "Bố cục biểu đồ dựng sẵn",
    "capability.upsell.layout_preset.benefit": "Bắt đầu với một bố cục đã lưu thay vì một biểu đồ đơn lẻ.",
    "capability.upsell.chart_compare.title": "So sánh hai mã",
    "capability.upsell.chart_compare.benefit": "Chồng mã thứ hai lên để thấy sức mạnh tương đối.",
    // --- Data availability: trung thực, KHÔNG upsell ---
    "data.unadjusted.title": "Giá chưa được điều chỉnh theo sự kiện doanh nghiệp",
    "data.unadjusted.body": "Dữ liệu cổ tức và tách cổ chưa có, nên chỉ báo dài hạn có thể sai quanh ngày giao dịch không hưởng quyền.",
    "data.unadjusted.tag": "Chưa điều chỉnh",
    "data.localOnly.badge": "Chỉ lưu trên thiết bị này",
    "data.localOnly.body": "Gói của bạn chưa bật đồng bộ cloud, nên dữ liệu này không xuất hiện ở thiết bị khác.",
    "data.exportLoaded.badge": "Chỉ dữ liệu đang tải",
    "data.exportLoaded.body": "Chỉ xuất các nến đang có trong bộ nhớ, không phải toàn bộ lịch sử trên server.",
    "data.sessionsDefault.badge": "Lịch mặc định",
    "data.sessionsDefault.body": "Đang dùng lịch giao dịch tích hợp sẵn của sàn. Bạn có thể sửa trong Cài đặt.",
    "data.whaleCampaignUnavailable": "Hiện chưa có dữ liệu chiến dịch cho mã này.",
    "data.indexApprox.badge": "Gần đúng",
    "data.indexApprox.body": "Dựng từ nhóm ngành vì dữ liệu cấu thành chỉ số chính thức chưa có.",
    "data.deepHistoryLimited.badge": "Đã đạt giới hạn nến trong ngày",
    "data.backtestLimited.badge": "Giới hạn bản dùng thử",
    "data.backtestLimited.body": "Lần chạy này bị giới hạn. Backtest sâu trên server chạy trên toàn bộ lịch sử.",
    "data.dividendsMissing": "Chưa có lịch sử cổ tức cho mã này.",
    "data.alertLocalOnly.badge": "Cảnh báo chỉ chạy trong tab này",
    "data.alertLocalOnly.body": "Cảnh báo được đánh giá trong trình duyệt. Đóng tab là ngừng; cảnh báo cloud chạy ở server là tính năng doanh nghiệp.",
    "alert.toast.direction.above": "cắt lên trên",
    "alert.toast.direction.below": "cắt xuống dưới",
    "alert.toast.dismiss": "Bỏ qua cảnh báo",
    // A10 tự động nhận diện mô hình nến (PLAN_FRONTEND_PROPLUS_TRACKA_2026-09-28 §3.9).
    // Xem giải thích đặt ở `capability.messages.en.ts`.
    "pattern.scan.title": "Tự động nhận diện mô hình nến",
    "pattern.scan.hint": "Chỉ mô hình đã xác nhận. Không vẽ gì trước khi thị trường đã chứng minh.",
    "pattern.scan.shapes": "Mô hình",
    "pattern.scan.selectAll": "Chọn tất cả",
    "pattern.scan.clearAll": "Bỏ chọn",
    "pattern.scan.run": "Quét biểu đồ",
    "pattern.scan.none": "Không tìm thấy mô hình đã xác nhận nào.",
    "pattern.scan.noData": "Chưa đủ nến đã đóng để quét.",
    "pattern.scan.skippedBusy": "Tạm dừng quét khi bạn đang kéo hoặc thu phóng.",
    "pattern.scan.skippedDisabled": "Nhận diện mô hình không khả dụng trên gói hoặc thiết bị này.",
    "pattern.scan.unavailable": "Cần module Pro để tự động nhận diện mô hình. Cài @vninvestcharts/widget-pro để bật tính năng.",
    "pattern.shape.headAndShoulders": "Vai đầu vai",
    "pattern.shape.inverseHeadAndShoulders": "Vai đầu vai ngược",
    "pattern.shape.doubleTop": "Hai đỉnh",
    "pattern.shape.doubleBottom": "Hai đáy",
    "pattern.shape.triangle": "Tam giác",
    "pattern.direction.bullish": "Tăng",
    "pattern.direction.bearish": "Giảm",
    "pattern.detail.confirmed": "đã xác nhận",
    "pattern.detail.bars": "nến",
    "pattern.detail.r2Unknown": "R² không xác định",
};
